import React from "react";
import { Routes, Route } from "react-router-dom";

import Homepage from "../Pages/Home/HomePage";
import AboutCompanyPage from "../Pages/AboutCompanyPage/AboutCompanyPage";
import TestimonialPage from "../Pages/TestimonialPage/TestimonialPage";
import OurTeam from "../Pages/Team/OurTeam";
import Services from "../Pages/Services/Services";
import ServiceDetailPage from "../Pages/Services/ServiceDetailPage";
import CaseSinglePage from "../Pages/CaseStudy/CaseSinglePage";
import CasePage from "../Pages/CaseStudy/CasePage";
import ContactPage from "../Pages/Contact/Contact";
import ErrorPage from "../Pages/ErrorPage/ErrorPage";
import FaqPage from "../Pages/Home";
import WhyJoinUs from "../Pages/Careers/WhyJoin/WhyJoinUs";
import CurrentOpenings from "../Pages/Careers/CurrentOpening/CurrentOpenings";
import ApplyNow from "../Pages/Careers/ApplyNow/ApplyNow";
import PrivacyPage from "../Pages/PrivacyPage/PrivacyPage";
import TermPage from "../Pages/TermPage/TermPage";
import StatutoryAudits from "../Pages/Services/ServicesTypes/StatutoryAudits";
import InternalAuditsAndRiskAssessments from "../Pages/Services/ServicesTypes/InternalAuditsAndRiskAssessments";
import ManagementOperationalAudits from "../Pages/Services/ServicesTypes/ManagementOperationalAudits";
import CorporateGovernanceReviews from "../Pages/Services/ServicesTypes/CorporateGovernanceReviews";
import IFRSIndASCompliance from "../Pages/Services/ServicesTypes/IFRSIndASCompliance";
import DirectIndirectTaxAdvisory from "../Pages/Services/ServicesTypes/DirectIndirectTaxAdvisory";
import GSTComplianceLitigation from "../Pages/Services/ServicesTypes/GSTComplianceLitigation";
import InternationalTaxationTransferPricing from "../Pages/Services/ServicesTypes/InternationalTaxationTransferPricing";
import MASupportDueDiligence from "../Pages/Services/ServicesTypes/MASupportDueDiligence";
import BusinessValuationFinancialModelling from "../Pages/Services/ServicesTypes/BusinessValuationFinancialModelling";
import FundraisingDealStructuring from "../Pages/Services/ServicesTypes/FundraisingDealStructuring";
import PostMergerIntegration from "../Pages/Services/ServicesTypes/PostMergerIntegration";
import OutsourcedBookkeepingPayroll from "../Pages/Services/ServicesTypes/OutsourcedBookkeepingPayroll";
import ManagementReportingMIS from "../Pages/Services/ServicesTypes/ManagementReportingMIS";
import VirtualCFO from "../Pages/Services/ServicesTypes/VirtualCFO";
import FinancialProcessAutomation from "../Pages/Services/ServicesTypes/FinancialProcessAutomation";
import CorporateLawAdvisory from "../Pages/Services/ServicesTypes/CorporateLawAdvisory";
import ROCFilingsAndStatutoryRegisters from "../Pages/Services/ServicesTypes/ROCFilingsAndStatutoryRegisters";
import BoardGovernanceSupport from "../Pages/Services/ServicesTypes/BoardGovernanceSupport";
import FEMAComplianceForForeignEntities from "../Pages/Services/ServicesTypes/FEMAComplianceForForeignEntities";
import BusinessStrategyAndTransformation from "../Pages/Services/ServicesTypes/BusinessStrategyAndTransformation";
import PerformanceImprovementAndCostOptimisation from "../Pages/Services/ServicesTypes/PerformanceImprovementAndCostOptimisation";
import RiskManagementAndInternalControls from "../Pages/Services/ServicesTypes/RiskManagementAndInternalControls";
import DigitalTransformationAdvisory from "../Pages/Services/ServicesTypes/DigitalTransformationAdvisory";
import ESGReportingAndDisclosures from "../Pages/Services/ServicesTypes/ESGReportingAndDisclosures";
import SustainabilityStrategyAndCarbonFootprint from "../Pages/Services/ServicesTypes/SustainabilityStrategyAndCarbonFootprint";
import CSRComplianceAdvisory from "../Pages/Services/ServicesTypes/CSRComplianceAdvisory";
import IPOReadinessAssessment from "../Pages/Services/ServicesTypes/IPOReadinessAssessment";
import FinancialStatementRestatementAuditSupport from "../Pages/Services/ServicesTypes/FinancialStatementRestatementAuditSupport";
import InternalControlsCorporateGovernanceSetup from "../Pages/Services/ServicesTypes/InternalControlsCorporateGovernanceSetup";
import CoordinationWithMerchantBankersAndLegalAdvisors from "../Pages/Services/ServicesTypes/CoordinationWithMerchantBankersAndLegalAdvisors";
import IndependentCharteredAccountantToTheIssue from "../Pages/Services/ServicesTypes/IndependentCharteredAccountantToTheIssue";
import IndiaEntryEntityStructuring from "../Pages/Services/ServicesTypes/IndiaEntryEntityStructuring";
import BoardLevelFinancialAdvisory from "../Pages/Services/ServicesTypes/BoardLevelFinancialAdvisory";
import BusinessRegistrationsApprovalsLicenses from "../Pages/Services/ServicesTypes/BusinessRegistrationsApprovalsLicenses";
import CrossBorderStructuring from "../Pages/Services/ServicesTypes/CrossBorderStructuring";
import Calculator from "../Pages/Knoledge Bank/Calculators/Calculator";
import Links from "../Pages/Knoledge Bank/Links/links";
import Acts from "../Pages/Knoledge Bank/Acts/Acts";
import ActInfoPage from "../Pages/Knoledge Bank/Acts/actInfoPage";
import IFCDesignRiskReview from "../Pages/Services/ServicesTypes/IFCDesignRiskReview";
import ComplianceProcessAssessment from "../Pages/Services/ServicesTypes/ComplianceProcessAssessment";
import TaxStructuringOptimization from "../Pages/Services/ServicesTypes/TaxStructuringOptimization";
import ManagedPayrollPeopleCompliance from "../Pages/Services/ServicesTypes/ManagedPayrollPeopleCompliance";
import StrategicFinancialLeadershipWithoutAFullTimeCFO from "../Pages/Services/ServicesTypes/StrategicFinancialLeadershipWithoutAFullTimeCFO";
import BusinessPerformanceReview from "../Pages/Services/ServicesTypes/BusinessPerformanceReview";
import CapitalAllocationCashFlowPlanning from "../Pages/Services/ServicesTypes/CapitalAllocationCashFlowPlanning";
import InvestorLenderReporting from "../Pages/Services/ServicesTypes/InvestorLenderReporting";
import ServiceCategoryPage from "../Pages/Services/ServiceCategoryPage";
import ServiceGroupPage from "../Pages/Services/ServiceGroupPage";

const AllRoute = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="home" element={<Homepage />} />
        <Route path="about" element={<AboutCompanyPage />} />
        <Route path="services" element={<Services />} />

        {/* Services Routes */}
        <Route
          path="services/indiaEntryAndEntityStructuring"
          element={<IndiaEntryEntityStructuring />}
        />
        <Route
          path="services/femaAndCrossBorderAdvisory"
          element={<CrossBorderStructuring />}
        />
        <Route
          path="services/businessRegistrationsApprovalsAndLicenses"
          element={<BusinessRegistrationsApprovalsLicenses />}
        />

        <Route
          path="services/statutoryTaxAndInternalAudits"
          element={<StatutoryAudits />}
        />
        <Route
          path="services/managementAndOperationalAudits"
          element={<ManagementOperationalAudits />}
        />
        <Route
          path="services/ifcDesignAndRiskReview"
          element={<IFCDesignRiskReview />}
        />
        <Route
          path="services/complianceAndProcessAssessments"
          element={<ComplianceProcessAssessment />}
        />

        <Route
          path="services/directAndIndirectTaxAdvisory"
          element={<DirectIndirectTaxAdvisory />}
        />
        <Route
          path="services/gstComplianceAndLitigationSupport"
          element={<GSTComplianceLitigation />}
        />
        <Route
          path="services/internationalTaxationAndTransferPricing"
          element={<InternationalTaxationTransferPricing />}
        />
        <Route
          path="services/taxStructuringAndOptimization"
          element={<TaxStructuringOptimization />}
        />

        <Route
          path="services/outsourcedBookkeeping"
          element={<OutsourcedBookkeepingPayroll />}
        />
        <Route
          path="services/misAndManagementReporting"
          element={<ManagementReportingMIS />}
        />
        <Route
          path="services/financialProcessAutomation"
          element={<FinancialProcessAutomation />}
        />
        <Route
          path="services/managedPayrollAndPeopleCompliance"
          element={<ManagedPayrollPeopleCompliance />}
        />
        <Route
          path="services/ifrsIndAsAccountingSupport"
          element={<IFRSIndASCompliance />}
        />

        <Route
          path="services/corporateLawAndSecretarialAdvisory"
          element={<CorporateLawAdvisory />}
        />
        <Route
          path="services/rOCFilingsAndStatutoryRegisters"
          element={<ROCFilingsAndStatutoryRegisters />}
        />
        <Route
          path="services/boardAndShareholderGovernanceSupport"
          element={<BoardGovernanceSupport />}
        />
        <Route
          path="services/femaRbiComplianceForForeignOwnedEntities"
          element={<FEMAComplianceForForeignEntities />}
        />

        <Route
          path="services/iPOReadinessAssessment"
          element={<IPOReadinessAssessment />}
        />
        <Route
          path="services/financialStatementRestatementAndAuditSupport"
          element={<FinancialStatementRestatementAuditSupport />}
        />
        <Route
          path="services/internalControlsAndCorporateGovernanceSetup"
          element={<InternalControlsCorporateGovernanceSetup />}
        />
        <Route
          path="services/coordinationWithMerchantBankersAndLegalAdvisors"
          element={<CoordinationWithMerchantBankersAndLegalAdvisors />}
        />
        <Route
          path="services/independentCharteredAccountantCertificationServices"
          element={<IndependentCharteredAccountantToTheIssue />}
        />

        <Route
          path="services/mAndASupportAndDueDiligence"
          element={<MASupportDueDiligence />}
        />
        <Route
          path="services/businessValuationAndFinancialModeling"
          element={<BusinessValuationFinancialModelling />}
        />
        <Route
          path="services/fundraisingAndDealStructuring"
          element={<FundraisingDealStructuring />}
        />
        <Route
          path="services/postMergerIntegrationAssistance"
          element={<PostMergerIntegration />}
        />

        <Route
          path="services/businessStrategyAndTransformation"
          element={<BusinessStrategyAndTransformation />}
        />
        <Route
          path="services/performanceImprovementAndCostOptimization"
          element={<PerformanceImprovementAndCostOptimisation />}
        />
        <Route
          path="services/riskManagementAndInternalControls"
          element={<RiskManagementAndInternalControls />}
        />
        <Route
          path="services/digitalTransformationAdvisory"
          element={<DigitalTransformationAdvisory />}
        />

        <Route
          path="services/eSGReportingAndDisclosures"
          element={<ESGReportingAndDisclosures />}
        />
        <Route
          path="services/sustainabilityStrategyAndCarbonFootprintAnalysis"
          element={<SustainabilityStrategyAndCarbonFootprint />}
        />
        <Route
          path="services/cSRComplianceAdvisory"
          element={<CSRComplianceAdvisory />}
        />

        <Route path="services/virtualCfoServices" element={<VirtualCFO />} />

        <Route
          path="services/strategicFinancialLeadership"
          element={<StrategicFinancialLeadershipWithoutAFullTimeCFO />}
        />
        <Route
          path="services/strategicFinancialLeadershipWithoutAFullTimeCfo"
          element={<StrategicFinancialLeadershipWithoutAFullTimeCFO />}
        />
        <Route
          path="services/boardLevelFinancialAdvisory"
          element={<BoardLevelFinancialAdvisory />}
        />
        <Route
          path="services/businessPerformanceReview"
          element={<BusinessPerformanceReview />}
        />
        <Route
          path="services/capitalAllocationAndCashFlowPlanning"
          element={<CapitalAllocationCashFlowPlanning />}
        />
        <Route
          path="services/investorAndLenderReporting"
          element={<InvestorLenderReporting />}
        />

        <Route path="calculator" element={<Calculator />} />

        <Route path="case-studies" element={<CasePage />} />
        <Route
          path="service-category/:slug"
          element={<ServiceCategoryPage />}
        />
        <Route path="service-group/:slug" element={<ServiceGroupPage />} />
        <Route path="practice-single/:slug" element={<ServiceDetailPage />} />
        <Route path="case-single/:slug" element={<CaseSinglePage />} />
        <Route path="team" element={<OurTeam />} />
        <Route path="whyJoinUs" element={<WhyJoinUs />} />
        <Route path="currentOpenings" element={<CurrentOpenings />} />
        <Route path="applyNow" element={<ApplyNow />} />
        <Route path="testimonials" element={<TestimonialPage />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="404" element={<ErrorPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="privacyPage" element={<PrivacyPage />} />
        <Route path="termPage" element={<TermPage />} />
        <Route path="links" element={<Links />} />
        <Route path="acts" element={<Acts />} />
        <Route
          path="/acts/:categoryId/:actId/:chapterIndex"
          element={<ActInfoPage />}
        />
      </Routes>
    </div>
  );
};

export default AllRoute;
